export default __webpack_public_path__ + "static/media/body-background-0.f1ba6b6d.jpg";